export const ROUTING_PROVIDER_DEFAULTS = Object.freeze({
  graphhopper: Object.freeze({
    baseUrl: 'https://graphhopper.com/api/1'
  }),
  openrouteservice: Object.freeze({
    baseUrl: 'https://api.openrouteservice.org'
  }),
  'osrm-compatible': Object.freeze({
    baseUrl: 'https://router.project-osrm.org'
  })
});

export function getRoutingProviderDefaultBaseUrl (slug) {
  const key = String(slug || '').trim();
  return ROUTING_PROVIDER_DEFAULTS[key]?.baseUrl || '';
}

export function getRoutingProviderBaseUrl (provider) {
  const effectiveConfig = getRoutingProviderEffectiveConfig(provider);
  const configured = String(effectiveConfig?.baseUrl || provider?.config?.baseUrl || '').trim();
  if (configured) return configured.replace(/\/$/, '');
  return getRoutingProviderDefaultBaseUrl(provider?.slug).replace(/\/$/, '');
}

export function getRoutingProviderEffectiveConfig (provider) {
  const currentConfig = provider?.config || {};
  if (provider?.slug !== 'osrm-compatible') return currentConfig;

  const mode = String(currentConfig.mode || 'standard').trim().toLowerCase();
  const standardProfiles = Array.isArray(currentConfig.standardProfiles) ? currentConfig.standardProfiles : currentConfig.profiles;
  const endpoints = Array.isArray(currentConfig.proEndpoints) ? currentConfig.proEndpoints : [];
  if (mode !== 'pro' || !endpoints.length) {
    return {
      ...currentConfig,
      profiles: standardProfiles
    };
  }

  const selectedId = String(currentConfig.selectedProEndpointId || '').trim();
  const selectedEndpoint = endpoints.find((endpoint) => String(endpoint?.id || '') === selectedId) || endpoints[0];
  if (!selectedEndpoint) return currentConfig;

  return {
    ...currentConfig,
    ...selectedEndpoint,
    profiles: Array.isArray(selectedEndpoint.profiles) ? selectedEndpoint.profiles : currentConfig.profiles
  };
}

export function withRoutingProviderDefaults (provider) {
  if (!provider || typeof provider !== 'object') return provider;
  const defaultBaseUrl = getRoutingProviderDefaultBaseUrl(provider.slug);
  const currentConfig = provider.config || {};
  const nextBaseUrl = String(currentConfig.baseUrl || '').trim() || defaultBaseUrl;

  return {
    ...provider,
    config: {
      ...currentConfig,
      baseUrl: nextBaseUrl,
      ...(provider.slug === 'osrm-compatible'
        ? {
          mode: String(currentConfig.mode || 'standard').trim() || 'standard',
          standardProfiles: Array.isArray(currentConfig.standardProfiles) ? currentConfig.standardProfiles : [],
          proEndpoints: Array.isArray(currentConfig.proEndpoints) ? currentConfig.proEndpoints : [],
          selectedProEndpointId: String(currentConfig.selectedProEndpointId || '').trim()
        }
        : {})
    }
  };
}
